import type { ParsedField } from "../types"

export interface GroupedFields {
	basic: ParsedField[]
	advanced: ParsedField[]
}

/**
 * 기본 필드로 처리할 필드명 목록
 */
export const DEFAULT_BASIC_FIELDS = new Set(["image_url", "end_image_url", "image_urls", "enhance_prompt", "prompt", "output_size", "duration", "resolution", "ratio"])

/**
 * 필드를 basic/advanced 그룹으로 분류
 * - required 필드는 항상 basic으로 (Advanced Options에 숨기지 않음)
 * - DEFAULT_BASIC_FIELDS에 있는 필드는 basic으로
 * - 명시적 분류가 없는 필드는 advanced로 처리
 * 입력 배열의 순서(applyFieldOrdering 적용 후)를 그대로 유지한다
 */
export function groupFields(fields: ParsedField[]): GroupedFields {
	const basicSet = new Set(Array.from(DEFAULT_BASIC_FIELDS))

	const basic: ParsedField[] = []
	const advanced: ParsedField[] = []

	for (const field of fields) {
		if (field.required || basicSet.has(field.name)) {
			basic.push(field)
		} else {
			// 명시적 분류가 없는 필드는 advanced로 처리
			advanced.push(field)
		}
	}

	return { basic, advanced }
}
